import { FETCH_PRODUCT_DETAILS_ALL_PENDING, FETCH_PRODUCT_DETAILS_ALL_SUCCESS, FETCH_PRODUCT_DETAILS_ALL_ERROR } from '../action/productDetailsAllAction';

const initialState = {
    
    pending: false,
    productDetailsAll: [],
  
    error: null
}

const productDetailsAllReducer = (state = initialState, action) => {
   
    switch (action.type) {
        case FETCH_PRODUCT_DETAILS_ALL_PENDING:
            return {
                ...state,
                pending: true
            }
        case FETCH_PRODUCT_DETAILS_ALL_SUCCESS:
            return {
                ...state,
                pending: false,
                productDetailsAll: action.payload,
              
            }
        case FETCH_PRODUCT_DETAILS_ALL_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        default:
            return state;
    }
}
export default productDetailsAllReducer;
export const getproductDetailsAll = state => state.productDetailsAll;
export const getproductDetailsAllPending = state => state.pending;
export const getproductDetailsAllError = state => state.error;
